import { useSiteSetupActions } from "@inrange/building-manager-api-client";
import {
  Site,
  SiteElectricalSystem,
} from "@inrange/building-manager-api-client/models-site";
import DataIngestionConfigSection from "./DataIngestionConfigSection";
import HealthMonitoringConfigSection from "./HealthMonitoringConfigSection";

const MonitoringConfigSection = ({
  site,
  esysEntries,
  ingestionByEsys,
  onConfigureEsys,
  onConfigureHealth,
}: {
  site: Site;
  esysEntries: [string, SiteElectricalSystem][];
  ingestionByEsys: ReturnType<typeof useSiteSetupActions>["ingestionByEsys"];
  onConfigureEsys: (esysUuid: string) => void;
  onConfigureHealth: () => void;
}) => {
  return (
    <div className="d-flex flex-column gap-3">
      <DataIngestionConfigSection
        esysEntries={esysEntries}
        ingestionByEsys={ingestionByEsys}
        onConfigureEsys={onConfigureEsys}
      />
      <hr className="my-0" />
      <HealthMonitoringConfigSection
        site={site}
        onConfigureHealth={onConfigureHealth}
      />
    </div>
  );
};

export default MonitoringConfigSection;
